angular.module('ihestiaRestServicesBase')

/**
   * Ustawienia
   * @return {[type]} [description]
   */
  .factory('ihestiaRestServiceProviderAtena',[ 'IHestiaRestServiceProviderAtenaDef', function(IHestiaRestServiceProviderAtenaDef) {

    return new IHestiaRestServiceProviderAtenaDef();
  }]);